/* eslint-disable sort-keys */
export const COURSE_TREE_LEAF_BUTTON_TYPE = {
  /**
   * Combined "I would like to:" action dropdown (or single button when only one action applies).
   * Consolidates: Assign, Present, Download as PDF, Download.
   * This is the recommended first-position control for the default button layout.
   */
  ACTION_DROPDOWN: 'ACTION_DROPDOWN',
  // Legacy individual button types — still usable via custom courseTreeLeafButtonTypeOrderArray.
  TEACHER_BUTTON_PDF_AND_FLOWPAPER: 'TEACHER_BUTTON_PDF_AND_FLOWPAPER',
  TEACHER_BUTTON_VIEW: 'TEACHER_BUTTON_VIEW',
  DOWNLOAD_BUTTON: 'DOWNLOAD_BUTTON',
  TEACHER_BUTTON_LINK_TO_COURSE: 'TEACHER_BUTTON_LINK_TO_COURSE',
  TEACHER_BUTTON_ASSIGN: 'TEACHER_BUTTON_ASSIGN',
  TEACHER_BUTTON_PRESENT: 'TEACHER_BUTTON_PRESENT',
  TEACHER_BUTTON_REMOVE: 'TEACHER_BUTTON_REMOVE',
  /** Navigates directly to the gradebook summary for this resource (only visible when assignments exist). */
  TEACHER_BUTTON_GRADEBOOK: 'TEACHER_BUTTON_GRADEBOOK'
};

export const COURSE_TREE_LEAF_DEFAULT_BUTTON_TYPE_ORDER_ARRAY = [
  // Position 1: "I would like to:" combined action dropdown (Assign / Present / Download as PDF / Download)
  COURSE_TREE_LEAF_BUTTON_TYPE.ACTION_DROPDOWN,
  // Position 2: View (remains translatable per client)
  COURSE_TREE_LEAF_BUTTON_TYPE.TEACHER_BUTTON_VIEW,
  // Position 3: Gradebook — only visible when resourceActivityCount > 0
  COURSE_TREE_LEAF_BUTTON_TYPE.TEACHER_BUTTON_GRADEBOOK,
  // Remove stays as a standalone button when applicable
  COURSE_TREE_LEAF_BUTTON_TYPE.TEACHER_BUTTON_REMOVE,
  // Note: ASSIGN, PRESENT, DOWNLOAD_BUTTON, and TEACHER_BUTTON_PDF_AND_FLOWPAPER are intentionally
  // omitted from the default order — they are now consolidated under ACTION_DROPDOWN.
  // Clients using a custom courseTreeLeafButtonTypeOrderArray may still reference them directly.
];
